namespace $.$$ {

	export class $shm_hitalama_map_page_keyboard_move extends $.$shm_hitalama_map_page_keyboard_move {

		@ $mol_mem
		auto() {
			return new this.$.$mol_dom_listener(
				this.document(),
				'keydown',
				this.handler(),
				{ passive: false },
			)
		}

		document() {
			return this.$.$mol_dom_context.document
		}

		@ $mol_mem
		handler() {
			return $mol_wire_async( ( event: KeyboardEvent )=> {
				const shift = this.event_shift( event )
				if( !shift ) return
				if( event.defaultPrevented ) return
				if( this.Map_page().overlayed() ) return
				if( $shm_hitalama_is_input_focused() ) return

				const links = this.Map_page().selected_links()
				if( links.length === 0 ) return

				const step = this.step()
				if( step === 0 ) return

				event.preventDefault()
				event.stopPropagation()
				this.move( shift[0] * step, shift[1] * step )
			} )
		}

		event_shift( event: KeyboardEvent ): readonly [ number, number ] | null {
			if( event.altKey || event.ctrlKey || event.metaKey ) return null

			switch( event.key ) {
				case 'ArrowLeft': return [ -1, 0 ]
				case 'ArrowRight': return [ 1, 0 ]
				case 'ArrowUp': return [ 0, -1 ]
				case 'ArrowDown': return [ 0, 1 ]
			}

			return null
		}

		step() {
			return Number( this.$.$shm_hitalama_settings.widget_keyboard_move_step_px() ) || 0
		}

		@ $mol_action
		move( x: number, y: number ) {
			const page = this.Map_page()
			return $shm_hitalama_map_history.transaction( page.map(), 'Перемещение виджетов', ()=> {
				page.selected_links().forEach( link => {
					const widget = page.widget_by_link( link )
					if( widget.locked() ) return
					const view = page.Widget( link ).Sub()
					view.left( view.left() + x )
					view.top( view.top() + y )
				} )
			} )
		}

	}

}
